export const LEFT_HAND_THUMBS_UP = [
  {t: [-0.011, -0.0299, -0.0701], r: [0.1224, -0.1562, 0.6052, 0.771]},
  {t: [0.0025, -0.0017, -0.0854], r: [0.3796, -0.3776, 0.3843, 0.7521]},
  {t: [0.0162, 0.041, -0.1065], r: [0.6152, -0.1749, 0.0935, 0.763]},
  {t: [0.0204, 0.0676, -0.1116], r: [0.5992, -0.1247, 0.1335, 0.7795]},
  {t: [0.0225, 0.096, -0.1202], r: [0.5992, -0.1247, 0.1335, 0.7795]},
  {t: [-0.0042, -0.008, -0.0928], r: [0.1427, -0.2467, 0.6763, 0.6793]},
  {t: [0.0063, 0.0312, -0.155], r: [-0.4551, -0.5645, 0.3425, 0.5974]},
  {t: [0.0447, 0.0257, -0.1538], r: [0.7509, 0.6277, 0.1981, -0.053]},
  {t: [0.0396, 0.0184, -0.1338], r: [0.7246, 0.5124, 0.4244, 0.1797]},
  {t: [0.0207, 0.0148, -0.1212], r: [0.7246, 0.5124, 0.4244, 0.1797]},
  {t: [-0.0078, -0.0192, -0.0982], r: [0.109, -0.1737, 0.6698, 0.7137]},
  {t: [-0.0006, 0.0083, -0.163], r: [-0.4929, -0.5301, 0.4215, 0.5462]},
  {t: [0.0407, 0.0046, -0.1614], r: [0.705, 0.703, 0.0897, -0.0263]},
  {t: [0.0382, -0.0005, -0.132], r: [0.6279, 0.5816, 0.4074, 0.3186]},
  {t: [0.0165, -0.0021, -0.1217], r: [0.6279, 0.5816, 0.4074, 0.3186]},
  {t: [-0.0092, -0.031, -0.0993], r: [0.0472, -0.1416, 0.6514, 0.7439]},
  {t: [0.0006, -0.0142, -0.1626], r: [-0.5202, -0.4929, 0.4819, 0.5042]},
  {t: [0.0398, -0.0159, -0.1611], r: [0.6996, 0.7076, 0.0706, 0.0696]},
  {t: [0.0338, -0.0161, -0.1304], r: [0.5876, 0.6289, 0.3607, 0.3593]},
  {t: [0.0143, -0.0168, -0.1208], r: [0.5876, 0.6289, 0.3607, 0.3593]},
  {t: [-0.0081, -0.0426, -0.0982], r: [-0.0269, -0.0934, 0.6476, 0.7558]},
  {t: [0.0026, -0.0377, -0.1578], r: [0.5435, 0.4612, -0.5243, -0.4658]},
  {t: [0.0366, -0.0376, -0.1559], r: [0.6991, 0.7017, 0.0384, 0.1318]},
  {t: [0.032, -0.0347, -0.1344], r: [0.575, 0.6796, 0.2522, 0.3795]},
  {t: [0.0166, -0.0342, -0.1237], r: [0.575, 0.6796, 0.2522, 0.3795]},
] as const;

export const RIGHT_HAND_THUMBS_UP = [
  {t: [0.0317, -0.0212, -0.089], r: [0.2199, 0.1003, -0.594, 0.7673]},
  {t: [0.0223, 0.009, -0.1042], r: [0.4294, 0.285, -0.3619, 0.7768]},
  {t: [0.0158, 0.0521, -0.1273], r: [0.6012, 0.067, -0.0513, 0.7947]},
  {t: [0.0145, 0.0784, -0.1348], r: [0.597, 0.0134, -0.0918, 0.7968]},
  {t: [0.0163, 0.1065, -0.1446], r: [0.597, 0.0134, -0.0918, 0.7968]},
  {t: [0.0303, 0.0032, -0.1103], r: [0.2434, 0.2002, -0.656, 0.6858]},
  {t: [0.0337, 0.0475, -0.1698], r: [-0.3298, 0.4729, -0.4297, 0.6949]},
  {t: [-0.0026, 0.0462, -0.1835], r: [0.7134, -0.6368, -0.0002, -0.2925]},
  {t: [-0.0107, 0.0369, -0.1654], r: [0.7745, -0.5891, -0.2133, -0.0877]},
  {t: [-0.0047, 0.0282, -0.145], r: [0.7745, -0.5891, -0.2133, -0.0877]},
  {t: [0.0347, -0.0077, -0.1158], r: [0.2088, 0.1254, -0.6589, 0.7117]},
  {t: [0.0416, 0.0251, -0.1782], r: [-0.3597, 0.4829, -0.4746, 0.6421]},
  {t: [0.0018, 0.0251, -0.19], r: [-0.673, 0.7069, -0.0014, 0.2177]},
  {t: [-0.0077, 0.0162, -0.163], r: [0.6957, -0.6456, -0.2988, 0.0994]},
  {t: [0.0063, 0.0104, -0.1443], r: [0.6957, -0.6456, -0.2988, 0.0994]},
  {t: [0.0361, -0.0196, -0.1178], r: [0.1467, 0.0923, -0.6537, 0.7367]},
  {t: [0.0398, 0.0027, -0.1801], r: [-0.3611, 0.446, -0.5466, 0.6099]},
  {t: [0.0028, 0.0047, -0.193], r: [-0.6782, 0.7246, -0.0014, 0.1226]},
  {t: [-0.003, -0.0006, -0.1628], r: [-0.652, 0.6801, 0.2937, -0.1613]},
  {t: [0.0108, -0.0046, -0.1465], r: [-0.652, 0.6801, 0.2937, -0.1613]},
  {t: [0.0343, -0.0315, -0.1182], r: [0.0757, 0.0463, -0.6692, 0.7378]},
  {t: [0.0363, -0.021, -0.1779], r: [-0.3141, 0.3981, -0.6168, 0.602]},
  {t: [0.0062, -0.0166, -0.1931], r: [-0.6691, 0.7354, -0.0331, 0.1021]},
  {t: [0.0012, -0.0185, -0.1716], r: [-0.6175, 0.7316, 0.235, -0.168]},
  {t: [0.0116, -0.0223, -0.1564], r: [-0.6175, 0.7316, 0.235, -0.168]},
] as const;
